// Selectors shared by the four design variants. Kept out of the components so
// each variant differs only in arrangement, not in how it picks/sorts results.

import { BENEFITS } from '@/benefits-flow/engine/benefits';
import type { Evaluation } from '@/benefits-flow/engine/evaluate';
import type { BenefitResult } from '@/benefits-flow/engine/types';

export const eligibleResults = (ev: Evaluation): BenefitResult[] =>
  ev.results.filter((r) => r.status === 'eligible');

export const moreInfoResults = (ev: Evaluation): BenefitResult[] =>
  ev.results.filter((r) => r.status === 'more-info-needed');

// Highest estimated max value first; non-cash benefits (null max) sort last.
export const byValueDesc = (results: BenefitResult[]): BenefitResult[] =>
  [...results].sort(
    (a, b) =>
      (BENEFITS[b.benefitId]?.max ?? -1) - (BENEFITS[a.benefitId]?.max ?? -1),
  );

// The single best action: the highest-value APPLY_NOW, else highest-value
// eligible of any actionable state.
export const nextBestAction = (ev: Evaluation): BenefitResult | undefined => {
  const eligible = byValueDesc(eligibleResults(ev));
  return eligible.find((r) => r.action === 'APPLY_NOW') ?? eligible[0];
};

export const actionGroup = (
  ev: Evaluation,
  actions: string[],
): BenefitResult[] =>
  byValueDesc(eligibleResults(ev).filter((r) => actions.includes(r.action)));
